import { fetchWithType } from './api';
import { getAdminUrl, getApiToken } from './helpers';

const subscribeToApsisNewsletter = async ({
  email,
  url,
}: {
  email: string;
  url: string;
}) => {
  return await fetchWithType<null>(`${getAdminUrl()}/api/subscribe`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${getApiToken()}`,
    },
    body: JSON.stringify({
      email,
      url,
    }),
  });
};

export { subscribeToApsisNewsletter };
